import { Link, NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { NAV } from "@/constants/testIds";

const PRINTIFY_URL = "https://bias-buster-store.printify.me/";

export function MobileMenu({ links, user, onClose, onLogout }) {
  return (
    <div className="xl:hidden border-t border-bbap-border bg-white px-4 py-4 space-y-3">
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} onClick={onClose} className="block text-zinc-700 hover:text-[#1E3A6E] py-1" data-testid={l.testId}>
          {l.label}
        </NavLink>
      ))}
      <a href={PRINTIFY_URL} target="_blank" rel="noopener noreferrer" className="block text-zinc-700 hover:text-[#1E3A6E] py-1" data-testid={NAV.merch}>
        Shop Merch
      </a>
      <Link to="/donate" onClick={onClose} data-testid={NAV.donate}>
        <Button className="w-full bg-zinc-950 text-white font-medium uppercase rounded-none">Donate</Button>
      </Link>
      {user === false && (
        <div className="flex gap-2 pt-2">
          <Link to="/login" className="flex-1" onClick={onClose} data-testid={NAV.login}>
            <Button variant="outline" className="w-full border-zinc-300 text-zinc-950 rounded-none">Log In</Button>
          </Link>
          <Link to="/register" className="flex-1" onClick={onClose} data-testid={NAV.register}>
            <Button className="w-full bg-zinc-950 text-white rounded-none">Sign Up</Button>
          </Link>
        </div>
      )}
      {user && (
        <div className="pt-2 space-y-2">
          <Link to="/dashboard" onClick={onClose} data-testid={NAV.dashboard} className="block text-zinc-700 hover:text-[#1E3A6E]">Dashboard</Link>
          {user.role === "admin" && (
            <>
              <Link to="/admin/scenarios" onClick={onClose} className="block text-zinc-700 hover:text-[#1E3A6E]">Admin: Add Scenario</Link>
              <Link to="/admin/subscribers" onClick={onClose} className="block text-zinc-700 hover:text-[#1E3A6E]">Admin: Email List</Link>
              <Link to="/admin/volunteers" onClick={onClose} className="block text-zinc-700 hover:text-[#1E3A6E]">Admin: Volunteers</Link>
            </>
          )}
          <button onClick={onLogout} data-testid="logout-button" className="block text-red-600">Log Out</button>
        </div>
      )}
    </div>
  );
}
